import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

export default function BookNewOrderModal({
  modalVisible,
  setModalVisible,
  onClose,
  messageType,
  status,
}) {

  useEffect(() => {
    if (modalVisible) {
      const timer = setTimeout(() => {
        setModalVisible(false);
      }, 2000);

      return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
    }
  }, [modalVisible, setModalVisible]);
    
  const handleModalClose = () => {
    setModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={modalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!modalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column px-5 py-5 gap-4"
            style={{
              borderRadius: "12px",
              backgroundImage:
                "radial-gradient(circle at left top, #fff, #fff)",
            }}
          >
             
            <div>
              <p className="text-xl font-medium text-center">
                {messageType === "offer"
                  ? "Offer Added "
                  : messageType === "edit"
                  ? "Garment Update"
                  : status === "success"
                  ? "Added to Cart! "
                  : "Failed to Add to Cart "}
                <img className="mx-2"
                  src={
                    messageType === "offer"
                      ? "Laundy_App_Icons_Gifs/Other_Icons/Added_to_cart_emoji.png"
                      : messageType === "edit"
                      ? "Laundy_App_Icons_Gifs/Other_Icons/Added_to_cart_emoji.png"
                      : status === "success"
                      ? "Laundy_App_Icons_Gifs/Other_Icons/Added_to_cart_emoji.png"
                      : "Laundy_App_Icons_Gifs/Other_Icons/Failed.png"
                  }
                  style={{
                    width: 24,
                    // height: 21,
                  }}
                />
              </p>
              <p className="text-lg font-medium text-center">
                {messageType === "offer"
                  ? "Your selected offer is added successfully!"
                  : messageType === "edit"
                  ? "Your selected Garment is updated successfully"
                  : status === "success"
                  ? "Your selected item is added to cart successfully! Place your order or add other!"
                  : "Your selected item can't added to cart! Please try again!"}
              </p>
            </div>
          </div>
        )}
      ></Dialog>
      <div></div>
    </div>
  );
}
